import Vue from 'vue'
import Vuex from 'vuex'
import authModules from './modules/auth';
import appModules from './modules/app';
import axios from 'axios';
import {apiHost} from '@/config/config';

Vue.use(Vuex)

Vue.prototype.$http = axios;
Vue.prototype.$axios = axios;
Vue.prototype.$apiHost = apiHost;

export default new Vuex.Store({
    modules :{
        auth : authModules,
        app : appModules
    },
});